import {
    fetch
} from '@/plugin/axios/index.js'

/**
 * 添加
 * @param {Object} data
 */
export function saveData(data) {
    return fetch({
        url: '/sale/trackTemplate/save',
        method: 'POST',
        data
    })
}


/**
 * @param {Object} data
 * 复制
 */
export function copyData(id) {
    return fetch({
        url: '/sale/trackTemplate/copy',
        method: 'GET',
        params: {
            id
        },
    })
}

/**
* 列表
* @param {Object} data
*/
export function getPageList(data) {
    return fetch({
        url: '/sale/trackTemplate/pageList',
        method: 'POST',
        data
    })
}


/**
 * @param {Object} data
 * 详情
 */
export function getDetail(id) {
    return fetch({
        url: '/sale/trackTemplate/detail',
        method: 'GET',
        params: {
            id
        },
    })
}


/**
 * @param {Object} data
 * 删除
 */
export function deleteRow(data) {
    return fetch({
        url: '/sale/trackTemplate/delete',
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/salesManagement/gzmb.js